import DashboardChartCaseTypeFilter from "./DashboardChartCaseTypeFilter";

export default DashboardChartCaseTypeFilter;
